import { MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";

import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { RootState } from "../redux/setupStore";
import { clearError } from "../redux/slices/appSlice";

const GlobalErrorMessage: React.FC = () => {
  const globalError = useAppSelector((state: RootState) => state.appState.error);
  const dispatch = useAppDispatch();

  return globalError === "" ? null : (
    <MessageBar
      messageBarType={MessageBarType.error}
      dismissButtonAriaLabel="Close error message"
      onDismiss={() => dispatch(clearError())}
      data-testid="global-error-message"
    >
      {globalError}
    </MessageBar>
  );
};

export default GlobalErrorMessage;
